import { PimcoreEntityType, PimcoreEntityNavigation } from '@/types/entity';

export default class EntityResolver {
  static entitiesMap(entities: Array<PimcoreEntityType>): Array<PimcoreEntityNavigation> {
    return entities
      .filter((entity) => entity.name.includes('Listing'))
      .map((entity) => {
        const itemEntityName = entity.name.replace('Listing', '');
        const itemEntity = this.findEntityByName(entities, itemEntityName);
        const entityNavigation: PimcoreEntityNavigation = {
          name: entity.name,
          title: entity.name.replace('get', '').replace('Listing', ''),
          type: itemEntity ? itemEntity.type.name : entity.type.name,
        };
        return entityNavigation;
      });
  }

  private static findEntityByName(entities: Array<PimcoreEntityType>, name: string) {
    return entities.find((entityItem) => entityItem.name === name);
  }
}
